import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, UncontrolledTooltip, Badge, UncontrolledPopover, PopoverBody
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';
// @ts-ignore
import  filterFactory, { selectFilter, multiSelectFilter, textFilter, numberFilter, Comparator  } from 'react-bootstrap-table2-filter';

import { ImgButton } from './ImgButtonComp';
import { Kennzahl } from './KennzahlComp';
import { KennzahlJR } from './KennzahlJRComp';


import { Chart } from "react-google-charts";

import { CollapseControl } from './CollapseControlComp';

import { GoogleChartWrapperChartType } from "react-google-charts/dist/types";

import { env } from '../env'

import * as Utilities from "./Utilities"

import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import Collapse from "@kunukn/react-collapse";

type State = {
    filterOpen: boolean,
    spaltenOpen: boolean,
    keColumns: string[],
    selectedLeft: string[],
    selectedRight: string[],
    weitereSpalten: string[],
    kommunentypen: KSLPlusAPI.Kommunentypen[],
    bundeslaender: string[],
    kommunenarten: number[],
    buchungsstile: string[],
    selectedEW: string[],
    einwohner: { name: string, min: number, max: number }[],
    visKE: KSLPlusAPI.KennzahlWert | null,
    visGK: KSLPlusAPI.GemeindeKennzahlenModel | null,
    kennzahlNamen: string[],
    filteredGKs: KSLPlusAPI.GemeindeKennzahlenModel[]
}

type Props = {    
    keVglData: KSLPlusAPI.KennzahlenVergleichModel,    
    token: string,
    kunde: number,
    vglKreis: number
}



const buchungsstile = ["kameral", "doppisch"];
const einwohner = [{ name: "unter 3000 Einwohner", min: 0, max: 2999 },    
    { name: "3000 bis unter 5000 Einwohner", min: 3000, max: 4999 },
    { name: "5000 bis unter 10000 Einwohner", min: 5000, max: 9999 },
    { name: "10000 bis unter 20000 Einwohner", min: 10000, max: 19999 },
    { name: "20000 bis unter 50000 Einwohner", min: 20000, max: 49999 },
    { name: "50000 bis unter 100000 Einwohner", min: 50000, max: 99999 },
    { name: "100000 bis unter 200000 Einwohner", min: 100000, max: 199999 },
    { name: "mehr als 200000 Einwohner", min: 200000, max: 99999999 }
]

export class KennzahlenVergleich extends Component<Props, State> {
    constructor(props: any) {
        super(props);


    }

    state: State = {
        filterOpen: false,
        spaltenOpen: false,
        keColumns: this.props.keVglData.kennzahlenNamen ?? [],
        selectedLeft: [],
        selectedRight: [],
        weitereSpalten: ["Verwaltung", "Bundesland", "Einwohner", "Art der Kommune"],
        kommunentypen: [],
        bundeslaender: [],
        kommunenarten: [],
        buchungsstile: ["kameral", "doppisch"],
        einwohner: einwohner.concat([]),
        selectedEW: einwohner.map(ew => ew.name),
        visKE: null,
        visGK: null,
        kennzahlNamen: [],
        filteredGKs:[]
    }


    node: any;
    container: any = null;
    getFilters: { (filter: string | undefined): void }[] = [];      


    getWeitereSpalten = () => {
        let spalten: string[] = ["Verwaltung", "Bundesland", "Einwohner", "Art der Kommune"];

        if (this.props.keVglData?.gemeindeKennzahlen?.findIndex(gk => (gk.buchungsart ?? 1) === 1) !== -1 && this.props.keVglData?.gemeindeKennzahlen?.findIndex(gk => (gk.buchungsart ?? 1) === 2) !== -1)
            spalten.push("Buchungsstil");

        return spalten;
    }

    calcFooter = (name: string) => {
        var werte: number[] = [];
        
        this.state.filteredGKs.forEach(gk => {
            if (gk.kennzahlenWerte) {
                var k = gk.kennzahlenWerte[name];

                if (k ) {
                    werte.push(k.wert??0);
                }
            }
        });
        werte = werte.sort((a, b) => a - b);

        if (werte.length === 0)
            return null;

        var sum = 0;
        var median = 0;
        werte.forEach(n => sum += n);
        if (werte.length % 2 == 1) {
            median = werte[Math.floor(werte.length / 2)];
        }
        else {
            median = (werte[Math.floor(werte.length / 2) - 1] + werte[Math.floor(werte.length / 2)]) / 2.0;
        }
        var mittel = sum / werte.length;

        sum = 0;
        var trim = Math.floor(werte.length / 10);
        if (trim == 0 && werte.length > 2) {
            trim = 1;
        }

        for (var i = trim; i < werte.length - trim; i++) {
            sum += werte[i];
        }
        var getrimmtesMittel = sum / (werte.length - 2 * trim);

        return { mittel: mittel, median: median, getrimmtesMittel: getrimmtesMittel };
    }

    createColumns = () => {
        var columns = [];


        var id = 1;


        id++;
        columns.push({
            dataField: 'guid',
            text: "Gemeinde",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '180px', textAlign: 'left' };
            },
            sort: true,
            sortCaret: (order: string, column: any) => {
                if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                return null;
            },
            sortFunc: (id1: string, id2: string, order: string, dataField: any) => {
                if (!this.props.keVglData || !this.props.keVglData.gemeindeKennzahlen)
                    return 0;
                var g1 = this.props.keVglData.gemeindeKennzahlen.find(gk => id1 === gk.guid);
                var g2 = this.props.keVglData.gemeindeKennzahlen.find(gk => id2 === gk.guid);
                if (!g1 || !g1.name || !g2 || !g2.name)
                    return 0;

                if (g1.kunde !== g2.kunde) {
                    if (g1.kunde === this.props.kunde)
                        return -1;
                    else if (g2.kunde === this.props.kunde)
                        return 1;
                }


                if (order === 'asc')
                    return g1.name.localeCompare(g2.name);
                else
                    return g2.name.localeCompare(g1.name)
            },
            //filterValue: (cell: string, row: KSLPlusAPI.GemeindeKennzahlenModel) => { alert(row.name); return row.guid },
            formatter: (cellContent: string, row: KSLPlusAPI.GemeindeKennzahlenModel) => {
                
                return (
                    <div>{row.name}</div>
                );

            }, 
            headerClasses: "kslplus-column-kevgl-name",
            classes: (col: any, row: KSLPlusAPI.GemeindeKennzahlenModel) => {
                if (this.props.vglKreis > 9999 && this.props.kunde !== -1 && (row.kundenObj?.kunde ?? -1) === this.props.kunde) {
                    return 'kslplus-row-kevgl-user';
                }

                return "kslplus-column-kevgl-name";
            },
            getFilter: (filter: any) => { this.getFilters.push(filter) },
            filter1: textFilter({
                onFilter: (value: string, data: KSLPlusAPI.GemeindeKennzahlenModel[]) => {
                    return data.filter(row => {
                        return row.guid == value;
                    })
                }
            }),
            filter: multiSelectFilter({
                options: this.getGemeindeOptions(),                
                onFilter: (value: string[], data: KSLPlusAPI.GemeindeKennzahlenModel[]) => { 
                    if (!value.length)
                        return data;

                    return data.filter(row => {
                        return value.findIndex(v => v === row.guid) !== -1;
                   })
                }
            }),
            footer: id,
            footerFormatter: (column: any, columnIndex: any) => {
                
                return (<div>
                             <div>Mittelwert<div className="kslplus-info-badge-container"><Badge className="kslplus-info-badge" id="ke-info-mittel">i</Badge><UncontrolledPopover className="kslplus-tooltip" placement="right" trigger="hover" target="ke-info-mittel"><PopoverBody><div className="kslplus-tooltip">Arithmetischer Mittelwert über alle Werte.</div></PopoverBody > </UncontrolledPopover></div></div>
                             <div>Getrimmter Mittelwert (10%)<div className="kslplus-info-badge-container"><Badge className="kslplus-info-badge" id="ke-info-getrimmtesmittel">i</Badge><UncontrolledPopover className="kslplus-tooltip" placement="right" trigger="hover" target="ke-info-getrimmtesmittel"><PopoverBody ><div className="kslplus-tooltip">Arithmetischer Mittelwert über alle Werte, unter Wegfall der größten 10% und kleinsten 10% der Werte.</div></PopoverBody > </UncontrolledPopover></div></div>
                             <div>Median (50%)<div className="kslplus-info-badge-container"><Badge className="kslplus-info-badge" id="ke-info-median">i</Badge><UncontrolledPopover className="kslplus-tooltip" placement="right" trigger="hover" target="ke-info-median"><PopoverBody ><div className="kslplus-tooltip">Zentralwert, bei welchem 50% der Werte größer und 50% der Wert kleiner sind. Bei einer geraden Anzahl von Werten, wird dieser Wert aus dem Mittelwert der beiden mittleren Werte gebildet.</div></PopoverBody > </UncontrolledPopover></div></div>
                        </div>);

            }
        });
        id++;

        if (this.state.weitereSpalten.find(s => s === "Verwaltung")) {
            columns.push({
                dataField: 'kundenObj.name',
                text: "Verwaltung",
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '180px', textAlign: 'left' };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                getFilter: (filter: any) => { this.getFilters.push(filter) },
                filter: selectFilter({
                    options: this.getVVOptions(),
                    placeholder: "Alle",
                    className: "kslplus-tabellen-multiselect",
                    style: { width: "145px" }
                }),
                footer: id

            });
            id++;
        }

        if (this.state.weitereSpalten.find(s => s === "Bundesland")) {
            columns.push({
                dataField: 'kundenObj.bundesland',
                text: "Bundesland",
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '180px', textAlign: 'left' };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                getFilter: (filter: any) => { this.getFilters.push(filter) },
                filter: selectFilter({
                    options: this.getBLOptions(),
                    placeholder: "Alle",
                    className: "kslplus-tabellen-multiselect",
                    style: { width: "145px" }
                }),
                footer: id
            
            });
            id++;
        }

        if (this.state.weitereSpalten.find(s => s === "Einwohner")) {
            columns.push({
                dataField: 'einwohner',
                text: "Einwohner",
                type: "number",
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '180px', textAlign: 'left' };
                },
                align: 'right',
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                getFilter: (filter: any) => { this.getFilters.push(filter) },                
                filter: numberFilter({
                    numberStyle: { width: '85px', marginLeft: '2px' }

                }),               
                formatter: (cellContent: string, row: KSLPlusAPI.GemeindeKennzahlenModel) => {

                    if (row.einwohner === 0)
                        return;

                    return (
                        <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(row.einwohner, 0, 3, '.', ',')}</div>

                    );
                },
                footer: id

                }
            );
            id++;
        }

        if (this.state.weitereSpalten.find(s => s === "Art der Kommune")) {
            columns.push({
                dataField: 'gemeindetyp',
                text: "Art der Kommune",                
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '180px', textAlign: 'left' };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                getFilter: (filter: any) => { this.getFilters.push(filter) },                
                formatter: (cellContent: number, row: KSLPlusAPI.GemeindeKennzahlenModel) => {  
                    if (!this.props.keVglData.kommunenTypen)
                        return;
                    const kt = this.props.keVglData.kommunenTypen.find(kt => kt.id === cellContent);
                    if (!kt)
                        return;

                    return (
                        <div className="kslplus-tabellen-data">{kt.bezeichnung} </div>

                    );
                },
                filter: selectFilter({
                    options: this.getKTOptions(),
                    placeholder: "Alle",
                    className: "kslplus-tabellen-multiselect",
                    style: { width: "145px" }
                }),
                footer: id


            }
            );
            id++;
        }

        if (this.state.weitereSpalten.find(s => s === "Buchungsstil") && this.getWeitereSpalten().findIndex(s => s === "Buchungsstil") !== -1) {
            columns.push({
                dataField: 'buchungsart',
                text: "Buchungsstil",
                headerStyle: (colum: any, colIndex: any) => {
                    return { width: '180px', textAlign: 'left' };
                },
                sort: true,
                sortCaret: (order: string, column: any) => {
                    if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                    else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                    else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                    return null;
                },
                getFilter: (filter: any) => { this.getFilters.push(filter) },
                formatter: (cellContent: number, row: KSLPlusAPI.GemeindeKennzahlenModel) => {                    
                    return (
                        <div className="kslplus-tabellen-data">{cellContent === 2 ? "doppisch" : "kameral" } </div>

                    );
                },
                filter: selectFilter({
                    options: [{ label: "kameral", value: 1}, { label: "doppisch", value: 2}],
                    placeholder: "Alle",
                    className: "kslplus-tabellen-multiselect",
                    style: { width: "145px" }
                }),
                footer: id


            }
            );
            id++;
        }

        if (this.props.keVglData.kennzahlenNamen) {
            
            this.state.keColumns.forEach(n => {                
                if (this.state.keColumns.findIndex(ke => ke === n) !== -1) {                 

                    columns.push({
                        dataField: "kennzahlenWerte[" + n + "]",//guid",
                        isDummyField: false,
                        text: n,
                        sort: true,     
                        align: 'right',
                        sortCaret: (order: string, column: any) => {
                            if (!order) return (<span className="kslplus-header-sort">&nbsp;&nbsp;&#8595;&#8593;</span>);
                            else if (order === 'asc') return (<span className="kslplus-header-sort-up">&nbsp;&nbsp;&#8593;</span>);
                            else if (order === 'desc') return (<span className="kslplus-header-sort-down">&nbsp;&nbsp;&#8595;</span>);
                            return null;
                        },
                        getFilter: (filter: any) => { this.getFilters.push(filter) },
                        //{ [key: string]: KSLPlusAPI.KennzahlModel; }
                        //sortFunc: (id1: string, id2: string, order: string, dataField: any) => {
                        sortFunc: (keA: KSLPlusAPI.KennzahlWert | undefined, keB: KSLPlusAPI.KennzahlWert |undefined, order: string, dataField: any) => {
                            /*
                            var ergA: KSLPlusAPI.KennzahlZeilenErgebnis|null = null;
                            if (keA && keA.zeilen && keA.zeilen.length)
                                ergA = keA.zeilen[keA.zeilen.length - 1];
                            var ergB: KSLPlusAPI.KennzahlZeilenErgebnis|null = null;
                            if (keB && keB.zeilen && keB.zeilen.length)
                                ergB = keB.zeilen[keB.zeilen.length - 1];
                            */
                            if (keA && keB) {

                                if (order === 'asc') {
                                    return (keB.wert ?? 0) - (keA.wert ?? 0);
                                }
                                return (keA.wert ?? 0) - (keB.wert ?? 0);
                            }
                            else if (keA) {
                                return -1;
                            }
                            else if (keB) {
                                return 1;
                            }
                            else
                                return 0;
                                
                            
                                

                        },
                        headerStyle: (colum: any, colIndex: any) => {
                            return { width: '240px', textAlign: 'left' };
                        },
                        formatter: (cellContent: string, row: KSLPlusAPI.GemeindeKennzahlenModel) => {

                            if (!row.kennzahlenWerte)
                                return null;

                            var ke = row.kennzahlenWerte[n];
                            

                            if (ke ) {
                                //var erg = ke.zeilen[ke.zeilen.length - 1];
                                //var nk = erg?.zeile?.nachkommastellen ?? 2;
                                var tid = "ke-info-" + ke.kennzahl?.id;
                                var tdtext = "Die Kennzahl wurde berechnet aus " + (ke.plantyp === 3 ? " der Jahresrechnung " : " dem Haushaltsplan ") + ke.jahr + "\n" + " Hier klicken, um die detaillierte Kennzahl zu sehen.";
                                
                                return (
                                    <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(ke.wert??0, ke.nk??2, 3, '.', ',') + " " + (ke.einheit??"")}<div className="kslplus-info-badge-container"><Badge className="kslplus-info-badge" id={tid} onClick={() => this.handleKZDetails(row, ke) }>i</Badge><UncontrolledPopover className="kslplus-tooltip" placement="right" trigger="hover" target={tid}><PopoverBody ><div className="kslplus-tooltip">{tdtext}</div></PopoverBody > </UncontrolledPopover></div>  </div>

                                );
                            }


                        },
                        filter: numberFilter({
                            numberStyle: { width: '85px', marginLeft: '2px' },
                            onFilter: (value: any, data: KSLPlusAPI.GemeindeKennzahlenModel[]) => 
                            {
                                if (value.comparator === "" || value.number === "")
                                    return data;
                                return data.filter(row => {
                                    if (!row.kennzahlenWerte)
                                        return false;

                                    var ke = row.kennzahlenWerte[n];


                                    if (ke ) {
                                        
                                        switch (value.comparator) {
                                            case ">":
                                                return (
                                                    (ke.wert??0) > value.number

                                                );

                                            case ">=":
                                                return (
                                                    (ke.wert ?? 0) >= value.number

                                                );

                                            case "<":
                                                return (
                                                    (ke.wert ?? 0) < value.number

                                                );

                                            case "=":
                                                return (
                                                    (ke.wert ?? 0) == value.number

                                                );

                                            case "<=":
                                                return (
                                                    (ke.wert ?? 0) <= value.number

                                                );

                                            case "!=":
                                                return (
                                                    (ke.wert ?? 0) != value.number

                                                );
                                        }
                                        
                                    }
                                });
                                
                            }
                        }),
                        footer: id,
                        footerAlign: 'right',
                        footerFormatter: (column: any, columnIndex: any) => {
                            var res = this.calcFooter(n);

                            if ( !res )
                                return null;

                            
                            return (<div><div className="kslplus-tabellen-data">{Utilities.FormatCurrency(res.mittel, 2, 3, '.', ',')}</div><div className="kslplus-tabellen-data">{Utilities.FormatCurrency(res.getrimmtesMittel, 2, 3, '.', ',')}</div><div className="kslplus-tabellen-data">{Utilities.FormatCurrency(res.median, 2, 3, '.', ',')}</div></div>);

                        }
                    });                    
                    id++;
                } 
            });
        }
        /*
        if (this.props.keVglData.kennzahlenNamen) {
            this.props.keVglData.kennzahlenNamen.forEach(n => {
                columns.push({
                    dataField: 'name',
                    text: n,
                    headerStyle: (colum: any, colIndex: any) => {
                        return { width: '120px', textAlign: 'left' };
                    },
                    formatter: (cellContent: string, row: KSLPlusAPI.GemeindeKennzahlenModel) => {
                        if (!row.kennzahlen)
                            return null;

                        var ke = row.kennzahlen[n];
                        if (ke && ke.zeilen && ke.zeilen.length) {
                            var erg = ke.zeilen[ke.zeilen.length];
                            var nk = erg?.zeile?.nachkommastellen ?? 2;

                            return (
                                <div className="kslplus-tabellen-data">{Utilities.FormatCurrency(erg.ergebnisPJ, nk, 3, '.', ',')} </div>

                            );
                        }

                    },
                    filter: textFilter()
                });
            }

            )
        }
        */


        return columns;
    }

    initFilters = () => {
        var gemeinden = this.getFilteredGemeindeKennzahlen(true, true);        
        this.state.kennzahlNamen = (this.props.keVglData?.kennzahlenNamen ?? []).filter(s => gemeinden.findIndex(g => g.kennzahlenWerte && g.kennzahlenWerte[s]) !== -1);
        
        if (this.props.keVglData?.userSettings) {
            
            this.setState({ keColumns: (this.props.keVglData?.userSettings[this.props.vglKreis]?.kennzahlenSpalten ?? this.state.kennzahlNamen).filter(n => this.state.kennzahlNamen.findIndex(n1 => n == n1) !== -1) });
            

            if (this.props.keVglData.userSettings[this.props.vglKreis]?.einwohner) {
                this.state.einwohner = einwohner.filter(e => this.props.keVglData?.userSettings && (this.props.keVglData?.userSettings[this.props.vglKreis]?.einwohner ?? []).findIndex(e1 => e.name == e1) !== -1);
            }
            
            this.setState({ bundeslaender: this.props.keVglData.userSettings[this.props.vglKreis]?.bundeslaender ?? this.getBundeslaender(), kommunenarten: this.props.keVglData.userSettings[this.props.vglKreis]?.gemeindearten ?? (this.props.keVglData?.kommunenTypen?.map(kt => kt.id ?? 0) ?? []), weitereSpalten: this.props.keVglData.userSettings[this.props.vglKreis]?.weitereSpalten ?? this.getWeitereSpalten(), buchungsstile: this.props.keVglData.userSettings[this.props.vglKreis]?.buchungsstile ?? buchungsstile.concat([]), selectedEW: this.props.keVglData.userSettings[this.props.vglKreis]?.einwohner ?? einwohner.map(ew => ew.name) });

            if (!this.props.keVglData.userSettings[this.props.vglKreis]) {
                this.props.keVglData.userSettings[this.props.vglKreis] = new KSLPlusAPI.UserKennzahlenVglSettingsModel();
                this.props.keVglData.userSettings[this.props.vglKreis].kennzahlenSpalten = (this.props.keVglData?.userSettings[this.props.vglKreis]?.kennzahlenSpalten ?? this.state.kennzahlNamen).filter(n => this.state.kennzahlNamen.findIndex(n1 => n == n1) !== -1);
                this.props.keVglData.userSettings[this.props.vglKreis].weitereSpalten = this.props.keVglData.userSettings[this.props.vglKreis]?.weitereSpalten ?? this.getWeitereSpalten();
                this.props.keVglData.userSettings[this.props.vglKreis].bundeslaender = this.props.keVglData.userSettings[this.props.vglKreis]?.bundeslaender ?? this.getBundeslaender();
                this.props.keVglData.userSettings[this.props.vglKreis].gemeindearten = this.props.keVglData.userSettings[this.props.vglKreis]?.gemeindearten ?? (this.props.keVglData?.kommunenTypen?.map(kt => kt.id ?? 0) ?? []);
                this.props.keVglData.userSettings[this.props.vglKreis].einwohner = this.props.keVglData.userSettings[this.props.vglKreis]?.einwohner ?? einwohner.map(ew => ew.name);
                this.props.keVglData.userSettings[this.props.vglKreis].buchungsstile = this.props.keVglData.userSettings[this.props.vglKreis]?.buchungsstile ?? buchungsstile.concat([]);                
            }
        }
        else {
            if (this.props.keVglData?.userSettings) {
                if (!this.props.keVglData.userSettings[this.props.vglKreis])
                    this.props.keVglData.userSettings[this.props.vglKreis] = new KSLPlusAPI.UserKennzahlenVglSettingsModel();



                this.props.keVglData.userSettings[this.props.vglKreis].kennzahlenSpalten = this.state.kennzahlNamen;
                this.props.keVglData.userSettings[this.props.vglKreis].weitereSpalten = this.getWeitereSpalten();
                this.props.keVglData.userSettings[this.props.vglKreis].bundeslaender = this.getBundeslaender();
                this.props.keVglData.userSettings[this.props.vglKreis].gemeindearten = this.props.keVglData?.kommunenTypen?.map(kt => kt.id ?? 0) ?? [];
                this.props.keVglData.userSettings[this.props.vglKreis].einwohner = einwohner.map(ew => ew.name);
                this.props.keVglData.userSettings[this.props.vglKreis].buchungsstile = buchungsstile.concat([]);
                
            }
            this.setState({ keColumns: this.state.kennzahlNamen, bundeslaender: this.getBundeslaender(), kommunenarten: this.props.keVglData?.kommunenTypen?.map(kt => kt.id ?? 0) ?? [], weitereSpalten: this.getWeitereSpalten(), buchungsstile: buchungsstile.concat([]), selectedEW: einwohner.map(ew => ew.name) });
        }

    }

    componentDidUpdate(prevProps: Props) {
        if ( this.props.vglKreis != prevProps.vglKreis) {
            this.initFilters();
        }        
    }


    componentDidMount() {
        this.initFilters();
        /*
        if (this.props.keVglData?.userSettings?.einwohner) {
            this.state.einwohner = einwohner.filter(e => this.props.keVglData?.userSettings?.einwohner && this.props.keVglData.userSettings.einwohner.findIndex(e1 => e.name == e1) !== -1);
        }
        */
        
        
        //this.setState({ bundeslaender: this.props.keVglData?.userSettings?.bundeslaender ?? [], kommunenarten: this.props.keVglData?.userSettings?.gemeindearten ?? [], weitereSpalten: this.props.keVglData?.userSettings?.weitereSpalten ?? [], buchungsstile: this.props.keVglData?.userSettings?.buchungsstile ?? [], selectedEW: this.props.keVglData?.userSettings?.einwohner ?? [] });
        //this.setState({ bundeslaender: this.getBundeslaender(), kommunenarten: (this.props.keVglData.kundenTypen ?? []).map(kt => kt.id??0 ) });
    }

    columnsKeNamenAll = [
        {
            dataField: 'name',
            text: 'Verfügbare Kennzahlen',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }    
    ]

    columnsKeNamenGenutzt = [
        {
            dataField: 'name',
            text: 'Angezeigte Kennzahlen',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }
    ]

    getKTOptions = () => {
        var items: any[] = []; 
        
        
        this.getFilteredGemeindeKennzahlen().forEach((gk) => {
            if (this.props.keVglData.kommunenTypen) {
                var kt = this.props.keVglData.kommunenTypen.find(kt => kt.id === gk.gemeindetyp);
                if (kt) {
                    if (!items.find(i => i.value === kt?.id))
                        items.push({ value: kt.id, label: kt.bezeichnung });    
                    }
                }
        });
        
        return items;
    }

    getBLOptions = () => {

        var items: any[] = [];        
        //if (!this.props.keVglData.gemeindeKennzahlen)
        //  return items;
        //var data = this.getFilteredGemeindeKennzahlen();

        this.getFilteredGemeindeKennzahlen().forEach((gk) => {
            if ( !items.find(i => i.value === gk.kundenObj?.bundesland) )            
                items.push({ value: gk.kundenObj?.bundesland, label: gk.kundenObj?.bundesland });
        });


        return items = items.sort((i1, i2) => i1.value.localeCompare(i2.value));
    }

    getVVOptions = () => {

        var items: any[] = [];
        //if (!this.props.keVglData.gemeindeKennzahlen)
          //  return items;

        this.getFilteredGemeindeKennzahlen().forEach((gk) => {
            if (!items.find(i => i.value === gk.kundenObj?.name))
                items.push({ value: gk.kundenObj?.name, label: gk.kundenObj?.name });
        });


        return items = items.sort((i1, i2) => i1.value.localeCompare(i2.value));
    }

    getGemeindeOptions = () => {

        var items: { [key: string]: string } = {};
        
        
        this.getFilteredGemeindeKennzahlen().forEach((gk) => {                        
            if ( gk.guid && gk.name )
                items[gk.guid] = gk.name;
        });

        return items;
        //return items = items.sort((i1, i2) => i1.label.localeCompare(i2.label));
    }

    
    getBundeslaender = () => {

        var bl: string[] = [];
        if (!this.props.keVglData.gemeindeKennzahlen)
            return bl;

        this.props.keVglData.gemeindeKennzahlen.forEach((gk) => {
            if (!bl.find(bl => bl === gk.kundenObj?.bundesland ))
                bl.push(gk.kundenObj?.bundesland ?? "");
        });


        return bl = bl.sort();
    }

    columnsWeitereSpalten = [
        {
            dataField: 'name',
            text: 'Weitere Spalten',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }
    ]

    columnsBL = [
        {
            dataField: 'name',
            text: 'Bundesländer',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }
    ]

    columnsKT = [
        {
            dataField: 'bezeichnung',
            text: 'Art der Kommune',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }
    ]

    columnsBS = [
        {
            dataField: 'name',
            text: 'Buchungsstil',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }
    ]

    columnsEW = [
        {
            dataField: 'name',
            text: 'Einwohner',
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '380px', textAlign: 'left' };
            }
        }
    ]

    pagOptions = {
        sizePerPageList: [ {
            text: '5', value: 5
        }] // A numeric array is also available. the purpose of above example is custom the text
    };

    handleLeft2Right = () => {
        //this.state.keColumns = this.state.selectedLeft.concat(this.state.keColumns);

        this.resetFilters();
        this.state.keColumns = this.state.keColumns.concat(this.state.selectedLeft);
        this.setState({ selectedLeft: [], keColumns: this.state.keColumns });
        this.saveSettings();
    }

    handleRight2Left = () => {
        //this.state.keColumns = this.state.keColumns.filter(k => this.state.selectedRight.findIndex(k1 => k1 === k) === -1);
        this.resetFilters();
        this.state.keColumns = this.state.keColumns.filter(k => this.state.selectedRight.findIndex(k1 => k1 === k) === -1);
        this.setState({ selectedRight: [], keColumns: this.state.keColumns });
        this.saveSettings();

    }

    saveSettings = () => {
        

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        
        var client = new KSLPlusAPI.Kennzahlenvergleich_Client(api);

        if (this.props.keVglData?.userSettings) {
            if (!this.props.keVglData.userSettings[this.props.vglKreis])
                this.props.keVglData.userSettings[this.props.vglKreis] = new KSLPlusAPI.UserKennzahlenVglSettingsModel();


            
            this.props.keVglData.userSettings[this.props.vglKreis].kennzahlenSpalten = this.state.keColumns;
            this.props.keVglData.userSettings[this.props.vglKreis].weitereSpalten = this.state.weitereSpalten;
            this.props.keVglData.userSettings[this.props.vglKreis].bundeslaender = this.state.bundeslaender;
            this.props.keVglData.userSettings[this.props.vglKreis].gemeindearten = this.state.kommunenarten;
            this.props.keVglData.userSettings[this.props.vglKreis].einwohner = this.state.selectedEW;
            this.props.keVglData.userSettings[this.props.vglKreis].buchungsstile = this.state.buchungsstile;
        }

        if (this.props.keVglData?.userSettings && this.props.keVglData?.userSettings[this.props.vglKreis]) {
            client.saveUserSettings(this.props.vglKreis, this.props.token, this.props.keVglData.userSettings[this.props.vglKreis]).then(() => {            
            }).catch(Reason => {            
            });
        }

        


    }


    handleKZDetails = (gkm: KSLPlusAPI.GemeindeKennzahlenModel, kzw: KSLPlusAPI.KennzahlWert) => {

        if (gkm.settings && kzw.kennzahlErg) {
            this.setState({ visGK: gkm, visKE: kzw });
            return;
        }

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        let client = new KSLPlusAPI.Kennzahlenvergleich_Client(api);

       
        client.getKennzahl(gkm.kunde, gkm.gemeinde, kzw.jahr, kzw.plantyp, kzw.planstufe, kzw.kennzahl?.id, gkm.buchungsart, this.props.token).then((kzErg) => {
            kzErg.kennzahl = kzw.kennzahl;  // kenzzahl in Ergebnis speisen --> wird in KennzahlComp benötigt
            kzw.kennzahlErg = kzErg;
            this.setState({ visKE: kzw });
        }).catch(Reason => {
            
        });
        

        let client1 = new KSLPlusAPI.DigitalHoushold_Client(api);
        client1.settings(gkm.kunde ?? 0, gkm.gemeinde ?? 0, kzw.jahr ?? 0, kzw.plantyp??0, kzw.planstufe??0, gkm.buchungsart??0, false, this.props.token).then((settings) => {
            gkm.settings = settings;
            this.setState({ visGK: gkm });
        }).catch(Reason => {            
        });



    }

    getSelectRowLeft = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.selectedLeft.map(m => m),
            onSelect: (row: { name: string }, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {
                    this.state.selectedLeft.push(row.name);

                    this.setState({ selectedLeft: this.state.selectedLeft });
                }
                else {
                    const index = this.state.selectedLeft.indexOf(row.name, 0);
                    
                    if (index > -1) {
                        this.state.selectedLeft.splice(index, 1);
                        this.setState({ selectedLeft: this.state.selectedLeft });
                    }                    
                }

            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {       
                    this.state.selectedLeft = (this.state.kennzahlNamen.filter(m => this.state.keColumns.findIndex(m1 => m === m1) === -1)).concat([]);
                    this.setState({ selectedLeft: this.state.selectedLeft });
                    return this.state.selectedLeft.map(m => m);

                }
                else {                    
                    this.setState({ selectedLeft: [] });
                    return [];
                }
            }
        }
    }

    getSelectRowRight = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.selectedRight.map(m => m),
            onSelect: (row: {name: string}, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {                      
                    this.state.selectedRight.push(row.name);                    
                    this.setState({ selectedRight: this.state.selectedRight });
                }
                else {
                    const index = this.state.selectedRight.indexOf(row.name, 0);
                    
                    if (index > -1) {                        
                        this.state.selectedRight.splice(index, 1);
                        this.setState({ selectedRight: this.state.selectedRight });
                    }
                    

                }

            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {       
                    this.state.selectedRight = this.state.keColumns.concat([]);
                    this.setState({ selectedRight: this.state.selectedRight });
                    return this.state.selectedRight.map(m => m);

                }
                else {                    
                    this.setState({ selectedRight: [] });
                    return [];
                }
            }
        }
    }

    getSelectRowWeitereSpalten = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.weitereSpalten.map(m => m),
            onSelect: (row: { name: string }, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {
                    this.state.weitereSpalten.push(row.name);
                    this.setState({ weitereSpalten: this.state.weitereSpalten });
                }
                else {
                    const index = this.state.weitereSpalten.indexOf(row.name, 0);

                    if (index > -1) {
                        this.state.weitereSpalten.splice(index, 1);
                        this.setState({ weitereSpalten: this.state.weitereSpalten });
                    }
                }
                this.saveSettings();

            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {                    
                    this.state.weitereSpalten = this.getWeitereSpalten();
                    this.setState({ weitereSpalten: this.state.weitereSpalten });                                        
                }
                else {
                    this.state.weitereSpalten = [];
                    this.setState({ weitereSpalten: this.state.weitereSpalten });                    
                }
                this.saveSettings();
                return this.state.weitereSpalten.map(m => m);
            }
        }
    }

    getSelectRowBL = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.bundeslaender.map(m => m),
            onSelect: (row: { name: string }, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {
                    this.state.bundeslaender.push(row.name);
                    this.setState({ bundeslaender: this.state.bundeslaender });
                }
                else {
                    const index = this.state.bundeslaender.indexOf(row.name, 0);

                    if (index > -1) {
                        this.state.bundeslaender.splice(index, 1);
                        this.setState({ bundeslaender: this.state.bundeslaender });
                    }


                }
                this.saveSettings();
            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {
                    this.state.bundeslaender = this.getBundeslaender();
                    this.setState({ bundeslaender: this.state.bundeslaender });                    
                }
                else {
                    this.state.bundeslaender = [];
                    this.setState({ bundeslaender: this.state.bundeslaender });                    
                }
                this.saveSettings();
                return this.state.bundeslaender.map(m => m);
            }
        }
    }

    getSelectRowKT = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.kommunenarten,
            onSelect: (row: KSLPlusAPI.Kommunentypen, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {
                    this.state.kommunenarten.push(row.id??0);
                    this.setState({ kommunenarten: this.state.kommunenarten });
                }
                else {
                    const index = this.state.kommunenarten.indexOf(row.id??0, 0);

                    if (index > -1) {
                        this.state.kommunenarten.splice(index, 1);
                        this.setState({ kommunenarten: this.state.kommunenarten });
                    }


                }
                this.saveSettings();
            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {
                    this.state.kommunenarten = (this.props.keVglData.kommunenTypen ?? []).map(kt => kt.id ?? 0);
                    this.setState({ kommunenarten: this.state.kommunenarten });                    
                }
                else {
                    this.state.kommunenarten = [];
                    this.setState({ kommunenarten: this.state.kommunenarten });                    
                }                
                this.saveSettings();
                return this.state.kommunenarten;
            }
        }
    }

    getSelectRowBS = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.buchungsstile.map(m => m),
            onSelect: (row: { name: string }, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {
                    this.state.buchungsstile.push(row.name);
                    this.setState({ buchungsstile: this.state.buchungsstile });
                }
                else {
                    const index = this.state.buchungsstile.indexOf(row.name, 0);

                    if (index > -1) {
                        this.state.buchungsstile.splice(index, 1);
                        this.setState({ buchungsstile: this.state.buchungsstile });
                    }


                }
                this.saveSettings();
            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {
                    this.state.buchungsstile = buchungsstile.concat([]);
                    this.setState({ buchungsstile: this.state.buchungsstile });                    
                }
                else {
                    this.state.buchungsstile = [];
                    this.setState({ buchungsstile: this.state.buchungsstile });                    
                }                
                this.saveSettings();
                return this.state.buchungsstile.map(m => m);
            }
        }
    }

    getSelectRowEW = () => {

        return {
            mode: 'checkbox',
            clickToSelect: false,
            selected: this.state.selectedEW,
            onSelect: (row: {name: string, min: number, max: number}, isSelect: boolean, rowIndex: number, e: any) => {
                if (isSelect) {
                    this.state.einwohner.push(row);
                    this.state.selectedEW = this.state.einwohner.map(ew => ew.name);
                    this.setState({ einwohner: this.state.einwohner, selectedEW: this.state.selectedEW });
                }
                else {
                    const index = this.state.einwohner.indexOf(row, 0);

                    if (index > -1) {
                        this.state.einwohner.splice(index, 1);
                        this.state.selectedEW = this.state.einwohner.map(ew => ew.name); 
                        this.setState({ einwohner: this.state.einwohner, selectedEW: this.state.selectedEW });
                    }


                }
                this.saveSettings();

            },
            onSelectAll: (isSelect: boolean, rows: { name: string }[]) => {
                if (isSelect) {
                    this.state.einwohner = einwohner.concat([]);
                    this.state.selectedEW = this.state.einwohner.map(ew => ew.name); 
                    this.setState({ einwohner: this.state.einwohner, selectedEW: this.state.selectedEW });                    
                }
                else {
                    this.state.selectedEW = [];
                    this.state.einwohner = [];
                    this.setState({ einwohner: this.state.einwohner, selectedEW: this.state.selectedEW });                    
                }                
                this.saveSettings();
                return this.state.einwohner.map(ew => ew.name);
            }
        }
    }

    getFilteredGemeindeKennzahlen = (vglKreisOnly: boolean = false, userOnly: boolean = false) => {
        if (!this.props.keVglData.gemeindeKennzahlen)
            return [];
        
        var filtered = userOnly && this.props.kunde !== -1 ? this.props.keVglData.gemeindeKennzahlen.filter(gk => (gk.kundenObj?.kunde??-1) == this.props.kunde) : this.props.keVglData.gemeindeKennzahlen;
        filtered = filtered.filter(gk => (gk.vergleichskreise ?? []).findIndex(vk => vk.id === this.props.vglKreis) !== -1);         
        if (vglKreisOnly)
            return filtered;

        filtered = filtered.filter(gk => this.state.bundeslaender.findIndex(b => b === gk.kundenObj?.bundesland) !== -1);        
        filtered = filtered.filter(gk => this.state.kommunenarten.findIndex(b => b === gk.gemeindetyp) !== -1);
        // Nur wenn es mehrere Buchungsstile gibt
        if (this.props.keVglData?.gemeindeKennzahlen?.findIndex(gk => (gk.buchungsart ?? 1) === 1) !== -1 && this.props.keVglData?.gemeindeKennzahlen?.findIndex(gk => (gk.buchungsart ?? 1) === 2) !== -1)
            filtered = filtered.filter(gk => this.state.buchungsstile.findIndex(b => b === (gk.buchungsart === 1 ? "kameral" : "doppisch")) !== -1);
        filtered = filtered.filter(gk => this.state.einwohner.findIndex(e => (gk.einwohner ?? 0) >= e.min && (gk.einwohner ?? 0) <= e.max) !== -1);
        this.state.filteredGKs = filtered.filter(gk => this.state.keColumns.findIndex(c => gk.kennzahlenWerte && gk.kennzahlenWerte[c]) !== -1).sort((g1, g2) => {
            if (!g1 || !g1.name || !g2 || !g2.name)
                return 0;

            if (g1.kunde !== g2.kunde) {
                if (g1.kunde === this.props.kunde)
                    return -1;
                else if (g2.kunde === this.props.kunde)
                    return 1;
            }


            return g1.name.localeCompare(g2.name);
            
        });
        return this.state.filteredGKs; // filtered.filter(gk => this.state.keColumns.findIndex(c => gk.kennzahlen && gk.kennzahlen[c] ) !== -1);
    }

    resetFilters = () => {
        this.getFilters.forEach(fct => fct(""));
    }

    
    render() {       

        const rowClasses = (row: KSLPlusAPI.GemeindeKennzahlenModel, rowIndex: number) => {
            let classes = "kslplus-row-class";

            if (this.props.vglKreis > 9999 && this.props.kunde !== -1 && (row.kundenObj?.kunde ?? -1) === this.props.kunde ) {
                classes += ' kslplus-row-kevgl-user';
            }

            return classes;
        };

        return (
            
                <div>                                        
                    <CollapseControl text="Spaltenansicht (siehe unten)" expanded={this.state.spaltenOpen} onClick={() => this.setState({ spaltenOpen: !this.state.spaltenOpen })}>

                        <div className="kslplus-filter-kevgl-tab-container kslplus-filter-kevgl">
                            <div className="kslplus-inline-block-child-table">
                                <BootstrapTable className="inline-block-child" keyField='name' data={this.state.kennzahlNamen.filter(m => this.state.keColumns.findIndex(m1 => m === m1) === -1)?.map(name => ({ name }))} columns={this.columnsKeNamenAll} selectRow={this.getSelectRowLeft()} />
                            </div>
                            <div className="kslplus-inline-block-child-button">
                                <ImgButton className="kslplus-marging-bottom" type="toright" size="lg" disabled={this.state.selectedLeft.length == 0} onClick={this.handleLeft2Right} />
                                <ImgButton type="toleft" size="lg" disabled={this.state.selectedRight.length == 0} onClick={this.handleRight2Left} />
                            </div>
                            <div className="kslplus-inline-block-child-table">
                                <BootstrapTable className="inline-block-child" keyField='name' data={this.state.keColumns.map(name => ({ name }))} columns={this.columnsKeNamenGenutzt} selectRow={this.getSelectRowRight()} />
                            </div>
                            <div className="kslplus-inline-block-child-table">
                                <BootstrapTable className="inline-block-child" keyField='name' data={this.getWeitereSpalten().map(name => ({ name }))} columns={this.columnsWeitereSpalten} selectRow={this.getSelectRowWeitereSpalten()} />
                            </div>


                        </div>

                    </CollapseControl>
                    <CollapseControl text="Filter" expanded={this.state.filterOpen} onClick={() => this.setState({ filterOpen: !this.state.filterOpen })}>

                        <div className="kslplus-filter-kevgl-tab-container kslplus-filter-kevgl">
                            
                            <div className="kslplus-inline-block-child-table">                                
                                <BootstrapTable className="inline-block-child" keyField='name' data={this.getBundeslaender().map(name => ({ name }))} columns={this.columnsBL} selectRow={this.getSelectRowBL()} />
                            </div>
                            <div className="kslplus-inline-block-child-table">
                                <BootstrapTable className="inline-block-child" keyField='id' data={this.props.keVglData.kommunenTypen} columns={this.columnsKT} selectRow={this.getSelectRowKT()} />
                            </div>
                            <div className="kslplus-inline-block-child-table">
                                <BootstrapTable className="inline-block-child" keyField='name' data={einwohner} columns={this.columnsEW} selectRow={this.getSelectRowEW()} />
                            </div>
                            {this.getWeitereSpalten().findIndex(s => s === "Buchungsstil") !== -1 &&
                                <div className="kslplus-inline-block-child-table">
                                    <BootstrapTable className="inline-block-child" keyField='name' data={buchungsstile.map(name => ({ name }))} columns={this.columnsBS} selectRow={this.getSelectRowBS()} />
                                </div>}
                        </div>

                    </CollapseControl>
                
                    <div className="kslplus-content-kevgl">     
                        <Row>
                            <Col className="kslplus-kennzahlen-tab">                                
                            <BootstrapTable key={"kslplus-kennzahlen-tab_" + this.state.keColumns.length} className="kslplus-kennzahlen-tab" hover={true} bordered={true} keyField='guid' data={this.getFilteredGemeindeKennzahlen()} columns={this.createColumns()} filter={filterFactory({ afterFilter: (f: KSLPlusAPI.GemeindeKennzahlenModel[]) => { this.state.filteredGKs = f; } } )}  filterPosition="top" rowClasses={rowClasses} />

                            </Col>
                        </Row>    

                    </div>
                    <Modal id="ksl-modal-ke" size="xl" contentClassName="ksl-modal-ke" isOpen={this.state.visKE !== null && this.state.visGK !== null} toggle={() => this.setState({ visKE: null, visGK: null })} >
                    <ModalHeader toggle={() => this.setState({ visKE: null, visGK: null })}>{this.state.visGK?.name + " - " + this.state.visKE?.kennzahl?.bezeichnung}</ModalHeader>
                        <ModalBody>
                        {(this.state.visKE?.plantyp ?? 0) < 3 && this.state.visKE?.kennzahl && this.state.visKE?.kennzahlErg && this.state.visGK?.settings &&
                            <Kennzahl kennzahlErg={this.state.visKE.kennzahlErg} kennzahl={this.state.visKE.kennzahl} jahr={this.state.visKE.jahr ?? 0} plantyp={this.state.visKE.plantyp} settings={this.state.visGK.settings} verwaltung={true} />
                        }
                        {(this.state.visKE?.plantyp ?? 0) === 3 && this.state.visKE?.kennzahl && this.state.visKE?.kennzahlErg && this.state.visGK?.settings &&
                            <KennzahlJR kennzahlErg={this.state.visKE.kennzahlErg} kennzahl={this.state.visKE.kennzahl} jahr={this.state.visKE.jahr ?? 0} plantyp={this.state.visKE.plantyp} bilanz={this.state.visKE.kennzahl.bilanz ?? false} settings={this.state.visGK.settings} verwaltung={true} />
                        }
                        </ModalBody>
                    </Modal>
                </div>
        );
    }
}